import { grey } from "@mui/material/colors";

const styles = {
  button: {
    textTransform: "none",
    color: grey[400],
    borderRadius: 0,
    borderColor: grey[400],
    "&:hover": {
      color: "black",
    },
    fontSize: 13,
  },
  selected: {
    color: "black",
    borderColor: "black",
    backgroundColor: grey[50],
    fontSize: 13,
  },
  section: {
    mb: 3,
    width: { xs: "auto", lg: 550 },
  },
};

export default styles;
